import { resolveMediaUrl } from '../lib/media';

const SIZE_CLASS = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-16 w-16 text-lg'
} as const;

export type AvatarSize = keyof typeof SIZE_CLASS;

function initials(firstName?: string | null, lastName?: string | null): string {
  const a = (firstName?.trim()?.[0] ?? '').toUpperCase();
  const b = (lastName?.trim()?.[0] ?? '').toUpperCase();
  const combined = `${a}${b}`.trim();
  return combined || '?';
}

export interface AvatarProps {
  profilePictureUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: AvatarSize;
  className?: string;
  alt?: string;
}

export const Avatar = ({
  profilePictureUrl,
  firstName,
  lastName,
  size = 'md',
  className = '',
  alt
}: AvatarProps) => {
  const src = resolveMediaUrl(profilePictureUrl);
  const label = alt ?? ([firstName, lastName].filter(Boolean).join(' ') || 'Profil');
  const sizeClass = SIZE_CLASS[size];

  if (src) {
    return (
      <img
        src={src}
        alt={label}
        className={`shrink-0 rounded-full object-cover ring-1 ring-slate-200/80 ${sizeClass} ${className}`}
      />
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-brand-100 font-semibold text-brand-800 ring-1 ring-brand-200/80 ${sizeClass} ${className}`}
      aria-hidden={!!alt}
      title={label}
    >
      {initials(firstName, lastName)}
    </span>
  );
};
